import React from 'react';

import { type ThirdPartyConfigsBootstrap } from '../../../constants/schemas/3p-config';
import { SearchPageResultsBannerPlacement, type useOAuthHandlers } from '../search-page-results-banner-placement';

interface SearchPageResultsInlineBannerPlacementProps {
	thirdPartyConfigs: ThirdPartyConfigsBootstrap;
	availableProductsOrder: string[]; // Product keys in display order; connectors will be shown in this order
	useOAuthHandlers: useOAuthHandlers;
}

export const SearchPageResultsInlineBannerPlacement = ({
	thirdPartyConfigs,
	availableProductsOrder,
	useOAuthHandlers,
}: SearchPageResultsInlineBannerPlacementProps): React.JSX.Element | null => {
	return (
		<SearchPageResultsBannerPlacement
			placementId="search-page-results-inline"
			thirdPartyConfigs={thirdPartyConfigs}
			availableProductsOrder={availableProductsOrder}
			useOAuthHandlers={useOAuthHandlers}
		/>
	);
};
